import React from "react";
import SearchBox from "../SearchBox";
import Button from "../../atoms/Button";
import ExportIcon from "../ExportIcon";
import UploadIcon from "../UploadIcon";
import NewIcon from "../NewIcon";
import { User } from "../../../models/User";
import styles from "./LocationList.module.css";

interface LocationsToolbarProps {
  isExporting: boolean;
  isImporting: boolean;
  user: User | null;
  onAddLocationClick(): void;
  onExportClick(): void;
  onImportClick(): void;
  onSearchChange(search: string): void;
}

export default function LocationsToolbar(props: LocationsToolbarProps) {
  return (
    <div className={styles.toolbar}>
      <div className={styles.searchWrapper}>
        <SearchBox
          className="w-full"
          variant="toolbar"
          onChange={(search) => props.onSearchChange(search)}
        />
      </div>
      <div className={styles.actionGroup}>
        {props.user?.role.includes("AdminReadWrite") && (
          <Button
            classes={styles.newBtn}
            variant="outline-white-toolbar"
            size="sm"
            icon={<NewIcon />}
            label="New"
            onClick={props.onAddLocationClick}
          />
        )}

        <Button
          classes={styles.exportBtn}
          variant="outline-white-toolbar"
          size="sm"
          icon={<ExportIcon isExporting={props.isExporting} />}
          label="Export"
          disabled={props.isExporting}
          onClick={props.onExportClick}
        />

        {(props.user?.role.includes("AdminReadWrite") ||
          props.user?.role.includes("Customer")) && (
          <Button
            classes={styles.importBtn}
            variant="outline-white-toolbar"
            size="sm"
            icon={<UploadIcon isUploading={props.isImporting} />}
            label="Import"
            disabled={props.isImporting}
            onClick={props.onImportClick}
          />
        )}
      </div>
    </div>
  );
}
